module.exports = __webpack_public_path__ + "static/media/Политика за възнагражденията (Проект).8d697062.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Политика за възнагражденията (Проект).pdf
// module id = 118
// module chunks = 0